import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JobsRoutingModule } from './jobs-routing.module';
import { AddComponent } from './add/add.component';
import { ListComponent } from './list/list.component';
import { ViewComponent } from './view/view.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserModule } from '@angular/platform-browser';
import { ContractComponent } from './contract/contract.component';
import { ProjectsComponent } from './projects/projects.component';
import { ProductsComponent } from './products/products.component';
import { BillingReportsComponent } from './billing-reports/billing-reports.component';
import { QuillModule } from 'ngx-quill';
import { ContractSprintComponent } from './contract-sprint/contract-sprint.component';
import { ProductSprintComponent } from './product-sprint/product-sprint.component';
import { ProjectSprintComponent } from './project-sprint/project-sprint.component';
import { NewProjectComponent } from './new-project/new-project.component';
import { ModelComponent } from './model/model.component';
import { ModelViewComponent } from './model-view/model-view.component';
import { BundleSprintComponent } from './bundle-sprint/bundle-sprint.component';


@NgModule({
  declarations: [
    AddComponent,
    ListComponent,
    ViewComponent,
    ContractComponent,
    ProjectsComponent,
    ProductsComponent,
    BillingReportsComponent,
    ContractSprintComponent,
    ProductSprintComponent,
    ProjectSprintComponent,
    NewProjectComponent,
    ModelComponent,
    ModelViewComponent,
    BundleSprintComponent
  ],
  imports: [
    CommonModule,
    JobsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    SwiperModule,
    PipeModule,
    NgxDatatableModule, 
    NgxSpinnerModule,
    MatMenuModule,
    QuillModule.forRoot(),

  ],
})
export class JobsModule { }
